import { Box } from '@rocket/ui';
import { useState } from 'react';

import PriorityList from './PriorityList';
import PriorityListActionBar from './PriorityListActionBar';

// biome-ignore lint/suspicious/noExplicitAny: list items are caller-defined
type AnyData = any;

interface DualPriorityListProps {
  includeTitle?: string;
  excludeTitle?: string;
  includeItems?: Array<AnyData>;
  excludeItems?: Array<AnyData>;
  onIncludeItemsChanged?: (items: Array<AnyData>) => void;
  onExcludeItemsChanged?: (items: Array<AnyData>) => void;
  getId?: (item: AnyData) => AnyData;
  getLabel?: (item: AnyData) => AnyData;
}

const DualPriorityList = ({
  includeTitle = 'Include Items',
  excludeTitle = 'Exclude Items',
  includeItems = [],
  excludeItems = [],
  onIncludeItemsChanged = (f) => f,
  onExcludeItemsChanged = (f) => f,
  ...rest
}: DualPriorityListProps) => {
  const [includeSelectedItems, setIncludeSelectedItems] = useState<Array<AnyData>>([]);
  const [excludeSelectedItems, setExcludeSelectedItems] = useState<Array<AnyData>>([]);

  return (
    <Box display="grid" gridTemplateColumns="5fr 2fr 5fr" alignItems="center" justifyItems="center">
      <Box width="100%">
        <PriorityList
          {...rest}
          hideButtons
          items={includeItems}
          onItemsChanged={onIncludeItemsChanged}
          title={includeTitle}
          selectedItems={includeSelectedItems}
          onSelectedItemsChanged={setIncludeSelectedItems}
        />
      </Box>
      <Box width="100%">
        <PriorityListActionBar
          priorityLists={[
            {
              items: includeItems,
              selectedItems: includeSelectedItems,
              onItemsChanged: onIncludeItemsChanged,
              onSelectedItemsChanged: setIncludeSelectedItems,
            },
            {
              items: excludeItems,
              selectedItems: excludeSelectedItems,
              onItemsChanged: onExcludeItemsChanged,
              onSelectedItemsChanged: setExcludeSelectedItems,
            },
          ]}
        />
      </Box>
      <Box width="100%">
        <PriorityList
          {...rest}
          hideButtons
          hidePreferred
          items={excludeItems}
          onItemsChanged={onExcludeItemsChanged}
          title={excludeTitle}
          selectedItems={excludeSelectedItems}
          onSelectedItemsChanged={setExcludeSelectedItems}
        />
      </Box>
    </Box>
  );
};

export default DualPriorityList;
